import { Controller } from "stimulus"

// Gates a primary action (a button/submit or an <a> link) behind a required
// Terms & Conditions checkbox. The gated control stays disabled until the box
// is checked; attempting to trigger it while unchecked reveals an inline error.
//
// Usage: put data-controller="terms-consent" on an element wrapping BOTH the
// consent partial (which provides the "checkbox" and "error" targets) and the
// primary action. Mark the primary action with:
//   data-terms-consent-target="gated" data-action="click->terms-consent#guard"
export default class extends Controller {
  static targets = ["checkbox", "gated", "error"]

  connect() {
    this.refresh()
  }

  toggle() {
    this.refresh()
    if (this.satisfied && this.hasErrorTarget) {
      this.errorTarget.classList.add("d-none")
    }
  }

  // Safety net for controls that cannot be natively disabled (e.g. an <a>).
  guard(event) {
    if (this.satisfied) return true
    event.preventDefault()
    event.stopPropagation()
    if (this.hasErrorTarget) this.errorTarget.classList.remove("d-none")
    return false
  }

  refresh() {
    const disabled = !this.satisfied
    this.gatedTargets.forEach((el) => this.setDisabled(el, disabled))
  }

  setDisabled(el, disabled) {
    if (el.tagName === "BUTTON" || el.tagName === "INPUT") {
      el.disabled = disabled
    }
    el.classList.toggle("disabled", disabled)
    el.style.pointerEvents = disabled ? "none" : ""
    el.style.opacity = disabled ? "0.6" : ""
    el.setAttribute("aria-disabled", disabled ? "true" : "false")
  }

  // Consent is satisfied when the box is checked, or when there is no box to
  // check at all (existing stores never render the consent partial).
  get satisfied() {
    return !this.hasCheckboxTarget || this.checkboxTarget.checked
  }
}
